import React, { Component } from 'react';
import './DisableLandscape.css';

export default class DisableLandscape extends Component {

    render() {

        return (
            <div className="DisableLandscape"></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DisableLandscape/DisableLandscape.js